/* Central dialogvärd (A9). Monteras EN gång i App.js, direkt innanför ToastProvider,
   så att kpConfirm/kpPrompt fungerar i alla rutter — även fältappen och publika sidor.

   - Kö: en dialog i taget, följande väntar tills den första är besvarad.
   - Portal till document.body, z-index över alla modaler men under toasts.
   - Registrerar sin hanterare SYNKRONT under första renderingen (inte i en effekt):
     barnens effekter körs före förälderns, så ett barn som frågar i sin mount-effekt
     skulle annars få "ingen provider".
   - Avmonteras providern med väntande frågor besvaras de som Avbryt (inga hängande löften). */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { registerDialogHandler, dispatchEscape, setEscDispatcherMounted } from './dialogApi';
import ConfirmDialog from './ConfirmDialog';
import PromptDialog from './PromptDialog';

let reqCounter = 0;

export default function DialogProvider({ children }) {
  const [queue, setQueue] = useState([]);
  const queueRef = useRef(queue);
  queueRef.current = queue;

  const enqueue = useCallback((request) => new Promise((resolve) => {
    const id = ++reqCounter;
    setQueue((q) => [...q, { ...request, id, resolve }]);
  }), []);

  // Synkron registrering under första renderingen (se filhuvudet). Esc-lyssnaren
  // registreras här av samma skäl: den måste ligga FÖRE modulernas egna window-
  // lyssnare i capture-ordningen, annars stänger Esc fel lager (Bildbank-fyndet 2026-10-07).
  const [unregister] = useState(() => {
    const onKey = (e) => { dispatchEscape(e); };
    if (typeof window !== 'undefined') { window.addEventListener('keydown', onKey, true); setEscDispatcherMounted(true); }
    const un = registerDialogHandler(enqueue);
    return () => { un(); if (typeof window !== 'undefined') { window.removeEventListener('keydown', onKey, true); setEscDispatcherMounted(false); } };
  });

  useEffect(() => () => {
    unregister();
    queueRef.current.forEach((r) => r.resolve(r.kind === 'prompt' ? null : false));
  }, [unregister]);

  const current = queue[0] || null;

  const settle = useCallback((id, value) => {
    setQueue((q) => {
      const hit = q.find((r) => r.id === id);
      if (hit) hit.resolve(value);
      return q.filter((r) => r.id !== id);
    });
  }, []);

  return (
    <>
      {children}
      {current && current.kind === 'prompt' && (
        <PromptDialog
          key={current.id}
          open
          {...current}
          onSubmit={(text) => settle(current.id, text)}
          onCancel={() => settle(current.id, null)}
        />
      )}
      {current && current.kind !== 'prompt' && (
        <ConfirmDialog
          key={current.id}
          open
          {...current}
          onConfirm={() => settle(current.id, true)}
          onCancel={() => settle(current.id, false)}
        />
      )}
    </>
  );
}
